var map = {
	"./css.png": 1246,
	"./django.png": 7774,
	"./java.png": 7810,
	"./javafx.png": 9337,
	"./mongodb.png": 2067,
	"./mysql.png": 6247,
	"./node.png": 2369,
	"./react.png": 4526,
	"./tailwind.png": 4503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1999;